"use strict";
// WARNING: this file contains profanity. The below list of profane words is necessary for this tool to function properly.
// Do not read below this line if you do not wish to be exposed to lots of profane words
Object.defineProperty(exports, "__esModule", { value: true });
exports.profaneWords = void 0;
exports.profaneWords = new Map([
    [
        "de",
        [
            "abspritzen",
            "abstand",
            "abtreiben",
            "abtreibung",
            "anal",
            "anus",
            "arsch",
            "arschficker",
            "arschloch",
            "arschlöcher",
            "balltasche",
            "bastard",
            "bellend",
            "beschissen",
            "besoffen",
            "bestial",
            "bestialität",
            "blasen",
            "blutig",
            "bollok",
            "boob",
            "brüste",
            "buceta",
            "busen",
            "bälle",
            "cipa",
            "cunillingus",
            "deich",
            "dildo",
            "dildos",
            "dink",
            "duche",
            "dödel",
            "ejakulation",
            "ejakulieren",
            "ejakuliert",
            "esel",
            "fagging",
            "fanny",
            "felching",
            "fellatio",
            "ficken",
            "ficker",
            "fickt",
            "flansch",
            "fotze",
            "fotzen",
            "fuck",
            "fudge packer",
            "gammler",
            "gefickt",
            "geil",
            "geschissen",
            "gott verdammt",
            "gottverdammt",
            "hintern",
            "hoden",
            "hodensack",
            "hore",
            "hundeficker",
            "hure",
            "hurensohn",
            "hölle",
            "hündin",
            "hündinnen",
            "kacke",
            "kacken",
            "kippe",
            "klitoris",
            "kock",
            "lust",
            "lüstern",
            "masochist",
            "masturbieren",
            "mist",
            "muschi",
            "muschis",
            "mutter ficker",
            "nazi",
            "nigger",
            "nutte",
            "nutten",
            "onanieren",
            "orgasim",
            "orgasmen",
            "orgasmus",
            "pecker",
            "penis",
            "piss",
            "pisse",
            "pissen",
            "pisser",
            "pissoff",
            "pisst",
            "poop",
            "porno",
            "pornographie",
            "prostituierte",
            "pube",
            "rektum",
            "rimming",
            "sadist",
            "samen",
            "schamlippen",
            "scheisse",
            "scheiße",
            "scheißen",
            "schlampe",
            "schlampen",
            "schluchzen",
            "schmutz",
            "schnappen",
            "schrauben",
            "schwanz",
            "schwanzlutscher",
            "schwuchtel",
            "schwuchteln",
            "schwänze",
            "sex",
            "shag",
            "shagging",
            "smegma",
            "spalt",
            "sperma",
            "stechen",
            "stiche",
            "teppichmuncher",
            "tit",
            "titt",
            "titte",
            "titten",
            "transen",
            "turd",
            "vagina",
            "verdammt",
            "vergewaltigen",
            "vergewaltiger",
            "verzögern",
            "viagra",
            "vulva",
            "wang",
            "waschbär",
            "wichsen",
            "x bewertet",
            "xxx",
        ],
    ],
    [
        "en",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "arrse",
            "arse",
            "arses",
            "ass",
            "ass-fucker",
            "asses",
            "assfucker",
            "assfukka",
            "asshole",
            "assholes",
            "asswhole",
            "a_s_s",
            "a$$",
            "as$",
            "a$s",
            "b!tch",
            "b00bs",
            "b17ch",
            "b1tch",
            "ballbag",
            "balls",
            "ballsack",
            "bastard",
            "beastial",
            "beastiality",
            "bellend",
            "bestial",
            "bestiality",
            "bi+ch",
            "biatch",
            "bitch",
            "bitchboy",
            "bitcher",
            "bitchers",
            "bitches",
            "bitchin",
            "bitching",
            "bloody",
            "blow job",
            "blowjob",
            "blowjobs",
            "boiolas",
            "bollock",
            "bollok",
            "boner",
            "boob",
            "boobs",
            "booobs",
            "boooobs",
            "booooobs",
            "booooooobs",
            "breasts",
            "buceta",
            "bugger",
            "bullshit",
            "bum",
            "butt",
            "butts",
            "butthole",
            "buttmuch",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "cawk",
            "chink",
            "cipa",
            "cl1t",
            "clit",
            "clitoris",
            "clits",
            "cnut",
            "cock",
            "cock-sucker",
            "cockface",
            "cockhead",
            "cockmunch",
            "cockmuncher",
            "cocks",
            "cocksuck",
            "cocksucked",
            "cocksucker",
            "cocksucking",
            "cocksucks",
            "cocksuka",
            "cocksukka",
            "cok",
            "cokmuncher",
            "coksucka",
            "coon",
            "cox",
            "crap",
            "cum",
            "cummer",
            "cumming",
            "cums",
            "cumshot",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "cunt",
            "cuntlick",
            "cuntlicker",
            "cuntlicking",
            "cunts",
            "cyalis",
            "cyberfuc",
            "cyberfuck",
            "cyberfucked",
            "cyberfucker",
            "cyberfuckers",
            "cyberfucking",
            "d1ck",
            "damn",
            "dick",
            "dickhead",
            "dildo",
            "dildos",
            "dink",
            "dinks",
            "dirsa",
            "dlck",
            "dog-fucker",
            "doggin",
            "dogging",
            "donkeyribber",
            "doosh",
            "duche",
            "dyke",
            "ejaculate",
            "ejaculated",
            "ejaculates",
            "ejaculating",
            "ejaculatings",
            "ejaculation",
            "ejakulate",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "fag",
            "fagging",
            "faggitt",
            "faggot",
            "faggs",
            "fagot",
            "fagots",
            "fags",
            "fanny",
            "fannyflaps",
            "fannyfucker",
            "fanyy",
            "fatass",
            "fcuk",
            "fcuker",
            "fcuking",
            "feck",
            "fecker",
            "felching",
            "fellate",
            "fellatio",
            "fingerfuck",
            "fingerfucked",
            "fingerfucker",
            "fingerfuckers",
            "fingerfucking",
            "fingerfucks",
            "fistfuck",
            "fistfucked",
            "fistfucker",
            "fistfuckers",
            "fistfucking",
            "fistfuckings",
            "fistfucks",
            "flange",
            "fook",
            "fooker",
            "fuck",
            "fucka",
            "fucked",
            "fucker",
            "fuckers",
            "fuckhead",
            "fuckheads",
            "fuckin",
            "fucking",
            "fuckings",
            "fuckingshitmotherfucker",
            "fuckme",
            "fucks",
            "fuckwhit",
            "fuckwit",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "fukkin",
            "fuks",
            "fukwhit",
            "fukwit",
            "fux",
            "fux0r",
            "f_u_c_k",
            "gangbang",
            "gangbanged",
            "gangbangs",
            "gaylord",
            "gaysex",
            "goatse",
            "god-dam",
            "god-damned",
            "goddamn",
            "goddamned",
            "hardcoresex",
            "headass",
            "hoar",
            "hoare",
            "hoer",
            "hoes",
            "homo",
            "hore",
            "horniest",
            "horny",
            "hotsex",
            "jack-off",
            "jackoff",
            "jap",
            "jerk-off",
            "jism",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "knobead",
            "knobed",
            "knobend",
            "knobhead",
            "knobjocky",
            "knobjokey",
            "kock",
            "kondum",
            "kondums",
            "kum",
            "kummer",
            "kumming",
            "kums",
            "kunilingus",
            "l3i+ch",
            "l3itch",
            "labia",
            "lust",
            "lusting",
            "m0f0",
            "m0fo",
            "m45terbate",
            "ma5terb8",
            "ma5terbate",
            "masochist",
            "master-bate",
            "masterb8",
            "masterbat*",
            "masterbat3",
            "masterbate",
            "masterbation",
            "masterbations",
            "masturbate",
            "mo-fo",
            "mof0",
            "mofo",
            "mothafuck",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "mothafucked",
            "mothafucker",
            "mothafuckers",
            "mothafuckin",
            "mothafucking",
            "mothafuckings",
            "mothafucks",
            "motherfuck",
            "motherfucked",
            "motherfucker",
            "motherfuckers",
            "motherfuckin",
            "motherfucking",
            "motherfuckings",
            "motherfuckka",
            "motherfucks",
            "muff",
            "muthafecker",
            "muthafuckker",
            "mutherfucker",
            "n1gga",
            "n1gger",
            "nazi",
            "nigg3r",
            "nigg4h",
            "nigga",
            "niggah",
            "niggas",
            "niggaz",
            "nigger",
            "niggers",
            "nob",
            "nob jokey",
            "nobhead",
            "nobjocky",
            "nobjokey",
            "numbnuts",
            "nutsack",
            "orgasim",
            "orgasims",
            "orgasm",
            "orgasms",
            "p0rn",
            "pawn",
            "pecker",
            "penis",
            "penisfucker",
            "phonesex",
            "phuck",
            "phuk",
            "phuked",
            "phuking",
            "phukked",
            "phukking",
            "phuks",
            "phuq",
            "pigfucker",
            "pimpis",
            "piss",
            "pissed",
            "pisser",
            "pissers",
            "pisses",
            "pissflaps",
            "pissin",
            "pissing",
            "pissoff",
            "poop",
            "porn",
            "porno",
            "pornography",
            "pornos",
            "prick",
            "pricks",
            "pron",
            "pube",
            "pusse",
            "pussi",
            "pussies",
            "pussy",
            "pussys",
            "rectum",
            "retard",
            "rimjaw",
            "rimming",
            "s hit",
            "s.o.b.",
            "sadist",
            "schlong",
            "screwing",
            "scroat",
            "scrote",
            "scrotum",
            "semen",
            "sex",
            "sh!+",
            "sh!t",
            "sh1t",
            "shag",
            "shagger",
            "shaggin",
            "shagging",
            "shemale",
            "shi+",
            "shit",
            "shitdick",
            "shite",
            "shited",
            "shitey",
            "shitfuck",
            "shitfull",
            "shithead",
            "shiting",
            "shitings",
            "shits",
            "shitted",
            "shitter",
            "shitters",
            "shitting",
            "shittings",
            "shitty",
            "skank",
            "slut",
            "sluts",
            "smegma",
            "smut",
            "snatch",
            "son-of-a-bitch",
            "spac",
            "spunk",
            "s_h_i_t",
            "t1tt1e5",
            "t1tties",
            "teets",
            "teez",
            "testical",
            "testicle",
            "tit",
            "titfuck",
            "tits",
            "titt",
            "tittie5",
            "tittiefucker",
            "titties",
            "tittyfuck",
            "tittywank",
            "titwank",
            "tosser",
            "turd",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "twunter",
            "v14gra",
            "v1gra",
            "vagina",
            "viagra",
            "vulva",
            "w00se",
            "wang",
            "wank",
            "wanker",
            "wanky",
            "whoar",
            "whore",
            "willies",
            "willy",
        ],
    ],
    [
        "es",
        [
            "aborto",
            "anal",
            "ano",
            "culo",
            "follador de culo",
            "culos",
            "estúpido",
            "bolsa de pelota",
            "bolas",
            "bastardo",
            "campana",
            "bestial",
            "bestialidad",
            "perra",
            "perras",
            "quejas",
            "sangriento",
            "mamada",
            "bollok",
            "teta",
            "tetas",
            "los pechos",
            "buceta",
            "extremo",
            "muncher alfombra",
            "grieta",
            "cipa",
            "clítoris",
            "polla",
            "chupar la polla",
            "gallos",
            "mapache",
            "mierda",
            "semen",
            "corrida",
            "cunillingus",
            "coño",
            "maldita sea",
            "consolador",
            "consoladores",
            "tonto",
            "perro follador",
            "duche",
            "dique",
            "eyacular",
            "eyaculado",
            "eyacula",
            "eyaculación",
            "maricón",
            "fagging",
            "maricones",
            "felching",
            "felación",
            "brida",
            "follada",
            "cabron",
            "folladores",
            "maldito",
            "carajo",
            "folla",
            "fudge packer",
            "maldito sea",
            "infierno",
            "hore",
            "córneo",
            "tirón",
            "kock",
            "labios vaginales",
            "lujuria",
            "masoquista",
            "masturbarse",
            "madre folladora",
            "nazi",
            "negro",
            "niggers",
            "orgasimo",
            "orgasmo",
            "orgasmos",
            "pájaro carpintero",
            "pene",
            "mear",
            "molesto",
            "pisser",
            "orinando",
            "enojado",
            "pornografía",
            "porno",
            "pinchazo",
            "pinchazos",
            "pube",
            "coños",
            "violación",
            "violador",
            "recto",
            "retardar",
            "rimming",
            "sádico",
            "atornillar",
            "escroto",
            "sexo",
            "pelusa",
            "follar",
            "transexual",
            "cagadas",
            "cagado",
            "cagando",
            "de mierda",
            "skank",
            "puta",
            "putas",
            "smegma",
            "tizón",
            "arrebatar",
            "hijo de puta",
            "espacio",
            "agallas",
            "testículo",
            "zurullo",
            "vagina",
            "viagra",
            "vulva",
            "wang",
            "hacerse una paja",
            "x clasificado",
            "xxx",
        ],
    ],
    [
        "fr",
        [
            "avortement",
            "anal",
            "anus",
            "cul",
            "enculer",
            "culs",
            "connard",
            "connards",
            "sac de billes",
            "des balles",
            "bellend",
            "bestial",
            "bestialité",
            "chienne",
            "chiennes",
            "salope",
            "sanglant",
            "pipe",
            "bollok",
            "boob",
            "seins",
            "les seins",
            "buceta",
            "clochard",
            "bout",
            "tapis muncher",
            "fente",
            "cipa",
            "clitoris",
            "coq",
            "suceuse",
            "coqs",
            "nègre",
            "merde",
            "sperme",
            "éjaculation",
            "cunillingus",
            "chatte",
            "zut",
            "queue",
            "godemiché",
            "godes",
            "tremper",
            "baiseur de chien",
            "duché",
            "digue",
            "éjaculer",
            "éjaculé",
            "éjacule",
            "éjaculant",
            "pédé",
            "fagging",
            "fagot",
            "fagots",
            "penchant",
            "fellation",
            "bride",
            "baisée",
            "enfoiré",
            "baiseurs",
            "putain de",
            "fuckings",
            "baise",
            "emballeur de fudge",
            "damné",
            "putain",
            "enfer",
            "hore",
            "corné",
            "se branler",
            "kock",
            "les lèvres",
            "luxure",
            "convoitise",
            "masochiste",
            "masturber",
            "mère enculée",
            "nazi",
            "nègres",
            "orgasim",
            "orgasme",
            "orgasmes",
            "quéquette",
            "pénis",
            "pisse",
            "bourré",
            "pisser",
            "faire chier",
            "caca",
            "porno",
            "pornographie",
            "piquer",
            "piqûres",
            "pube",
            "chattes",
            "râpé",
            "violeur",
            "rectum",
            "retard",
            "rimming",
            "sadique",
            "scrotum",
            "sexe",
            "baiser",
            "transexuelle",
            "chier",
            "chié",
            "merdique",
            "skank",
            "salopes",
            "smegma",
            "cochonneries",
            "arracher",
            "fils de pute",
            "espacer",
            "cran",
            "testicule",
            "mésange",
            "titt",
            "vagin",
            "viagra",
            "vulve",
            "wang",
            "branler",
            "x évalué",
            "xxx",
        ],
    ],
]);
//# sourceMappingURL=profane-words.js.map